import {
  CaretDownOutlinedIcon,
  CaretUpOutlinedIcon,
} from '@trufla-technology/trumarket-react-design-system';
import './style.scss';

interface props {
  items: item[];
  sortingIndex: item;
  onChange: (e: string) => void;
}
interface item {
  key: string;
  label: string;
}
export const SortingLine = ({ items, onChange, sortingIndex }: props) => {
  const sortBy = sortingIndex.key;
  const sortOrder = sortingIndex.label;
  return (
    <div className="sorting-line">
      <p>Sort: </p>
      {items?.map((item: item) => {
        return (
          <button
            type="button"
            className={`${sortBy === item.key ? 'active' : ''}`}
            onClick={() => onChange(item.key)}
            key={item.key}
          >
            {item.label}
            {sortBy === item.key && sortOrder ? (
              <span>
                {sortOrder === 'asc' ? (
                  <CaretUpOutlinedIcon />
                ) : (
                  <CaretDownOutlinedIcon />
                )}
              </span>
            ) : (
              <span className="unselect-sorting">
                <CaretUpOutlinedIcon />
                <CaretDownOutlinedIcon />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
